import get from 'lodash/get';

export const parseContentFields = (contentFields) => contentFields.reduce((acc, curr) => ({
  ...acc,
  [curr.fieldDefinitionKey]: { ...curr }
}), {});

export const getFieldDataByKey = (fields, key, defaultValue) => {
  const data = get(fields, key);

  try {
    return JSON.parse(data) || defaultValue;
  } catch (e) {
    return data || defaultValue;
  }
};


// WEBPACK FOOTER //
// ./src/frontend/helpers/parser.js